import apiClient from './client'
import type { Attendance } from '../../../shared/src/types/api'

export const attendanceApi = {
  history: async (athleteId: string, from: string, to: string): Promise<Attendance[]> => {
    const { data } = await apiClient.get(`/athletes/${athleteId}/attendance`, { params: { from, to } })
    return data
  },
}
